import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d43e68a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "main-content-page-title w-full pb-2" }, "基本営業日設定", -1))
const _hoisted_2 = { id: "clinic-daily-routine__content" }
const _hoisted_3 = { class: "grid flex align-items-center my-4" }
const _hoisted_4 = { class: "month lg:col-2 sm:col-12" }
const _hoisted_5 = { class: "flex justify-content-end" }
const _hoisted_6 = { class: "flex justify-content-center" }
const _hoisted_7 = { class: "mt-6 w-9" }
const _hoisted_8 = ["onSubmit"]
const _hoisted_9 = { class: "flex justify-content-center" }

import { ApiClinicDailyRoutineRequest } from "@/clinic/typings";
import { get, set } from "@vueuse/core";
import { notityErrorMsg, notifySuccessMsg } from "@/clinic/utils/notify-utils";
import { ref, reactive, computed, withDefaults, onBeforeMount } from "vue";
import { useToast } from "primevue/usetoast";
import { ClinicBusinessDaySettingService } from "@/clinic/services";
import type { ApiBaseReq, IClinicBusinessDaySetting } from "@/clinic/typings";
import DateComponent from "../common/date.vue";
import SpecialDateComponent from "../common/special-date.vue";
import Toast from "primevue/toast";
import { WeekDays } from "@/clinic/typings/constants/clinic";
import ClinicApplySettingPrevMonthService from "@/clinic/services/clinic/apply-prev-month";
import moment from "moment";

type IForm = {
  clinicId: number;
  hasEdit?: boolean;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'form',
  props: {
    clinicId: null,
    hasEdit: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { clinicId: number, hasEdit: boolean };

const toast = useToast();



const form = reactive<any>({});

const getCurrentDateFormat = ref(moment().format("YYYY-MM-DD"));

const defaultSpecialDateObject = ref({
  date: getCurrentDateFormat,
  clinic_id: props.clinicId,
  clinic_business_day_setting_id: null,
  morning_shift_start: "8",
  morning_shift_start_minutes: "0",
  morning_shift_end: "12",
  morning_shift_end_minutes: "0",
  afternoon_shift_start: "13",
  afternoon_shift_start_minutes: "0",
  afternoon_shift_end: "18",
  afternoon_shift_end_minutes: "0",
  _destroy: false,
});
const specialDateElements = ref([]);
const dateElements = ref([]);

const addMoreSpecialDate = () => {
  const days = get(form).value.clinic_special_shift_settings_attributes;
  set(form, "clinic_special_shift_settings_attributes", days.push(defaultSpecialDateObject.value));
};

const onDeleteDate = index => {
  get(specialDateElements)[index].destroyDate();
  let days = get(form).value.clinic_special_shift_settings_attributes;
  if (days[index].id) {
    days[index]._destroy = true;
  } else {
    days.splice(index, 1);
  }
  set(form, "clinic_special_shift_settings_attributes", days);
};

const validate = async (passVal: boolean) => {
  set(pass, passVal);
};
const formRef = ref<HTMLFormElement>();
const pass = ref(false);

const handleApplyPrevMonth = async () => {
  const { prevMonth, prevYear } = handleGetNumberPreMonth(get(form.month), get(form.year));
  const params = {
    clinic_id: get(form.value.clinic_id),
    prev_month: prevMonth,
    prev_year: prevYear,
    month: get(form.month),
    year: get(form.year),
  };
  await ClinicApplySettingPrevMonthService.updateClinicRoutineDaily(
    params,
    get(form.value.clinic_id),
    () => notifySuccessMsg(toast, "保存が完了しました"),
    () => notityErrorMsg(toast, "何かが間違っています。後でもう一度試してください")
  );
  await loadModel();
};

const handleGetNumberPreMonth = (month: number, year: number) => {
  if (month === 1) {
    return { prevMonth: 12, prevYear: year - 1 };
  }
  return { prevMonth: month - 1, prevYear: year };
};

const submit = async () => {
  get(dateElements).forEach(date => {
    const dateData = date?.getDateData();
    if (dateData !== undefined) {
      Object.keys(dateData).forEach(key => {
        if (key.endsWith("_minute") && dateData[key]?.value !== "0") {
          const fieldName = key.replace("_minute", "");
          if (dateData[fieldName] === "NaN") {
            dateData[fieldName] = null;
          } else if (dateData[fieldName] !== null) {
            dateData[fieldName] += `:${dateData[key].value}`;
          }
        }
      });
      form.value = { ...form.value, ...dateData };
    }
  });
  let clinic_special_shift_settings_attributes: any[] = [];
  get(specialDateElements).forEach(specialDate => {
    if (specialDate?.getSpecialDateData() !== undefined) {
      const objectSpecialDate = specialDate?.getSpecialDateData();
      const morning_shift_start = objectSpecialDate.day_off
        ? ""
        : `${objectSpecialDate.morning_shift_start}:${objectSpecialDate.morning_shift_start_minutes}`;
      const morning_shift_end = objectSpecialDate.day_off
        ? ""
        : `${objectSpecialDate.morning_shift_end}:${objectSpecialDate.morning_shift_end_minutes}`;
      const afternoon_shift_start = objectSpecialDate.day_off
        ? ""
        : `${objectSpecialDate.afternoon_shift_start}:${objectSpecialDate.afternoon_shift_start_minutes}`;
      const afternoon_shift_end = objectSpecialDate.day_off
        ? ""
        : `${objectSpecialDate.afternoon_shift_end}:${objectSpecialDate.afternoon_shift_end_minutes}`;
      clinic_special_shift_settings_attributes.push({
        clinic_id: objectSpecialDate.clinic_id,
        date: objectSpecialDate.date,
        morning_shift_start: morning_shift_start,
        morning_shift_end: morning_shift_end,
        afternoon_shift_start: afternoon_shift_start,
        afternoon_shift_end: afternoon_shift_end,
        _destroy: objectSpecialDate?._destroy,
        id: objectSpecialDate.id,
      });
    }
  });
  if (!get(pass)) return;
  const formData = { ...form.value, ...{ clinic_id: get(props.clinicId), month: form.month, year: form.year } };
  formData.clinic_special_shift_settings_attributes = clinic_special_shift_settings_attributes;
  const payload = { ...formData } as unknown as ApiClinicDailyRoutineRequest;
  await ClinicBusinessDaySettingService.updateClinicRoutineDaily(
    payload,
    get(props.clinicId),
    () => notifySuccessMsg(toast, "保存が完了しました"),
    () => notityErrorMsg(toast, "何かが間違っています。後でもう一度試してください")
  );
  await loadModel();
};

const clinicIdParams = computed((): ApiBaseReq => ({ clinic_id: get(props.clinicId) }));

const loadModel = async () => {
  const params = {
    ...get(clinicIdParams),
    year: form.year,
    month: form.month,
  };
  await ClinicBusinessDaySettingService.getSetting(
    params,
    (setting: IClinicBusinessDaySetting) => set(form, setting),
    () => notityErrorMsg(toast, "何かが間違っています。後でもう一度試してください")
  );
};

const handleChangeMonth = async (direction: string) => {
  let year = form.year;
  let month = form.month;
  if (direction === "next") {
    if (++month > 12) {
      year++;
      month = 1;
    }
  } else {
    if (--month <= 0) {
      year--;
      month = 12;
    }
  }
  await loadDate(month, year);
  await loadModel();
  set(getCurrentDateFormat, moment(`${get(form.year)}-${get(form.month)}-01`, "YYYY-MM-DD").format("YYYY-MM-DD"));
};

const loadDate = (month: string | null = null, year: string | null = null) => {
  if (!month || !year) {
    const date = get(getCurrentDate);
    form.year = date.year;
    form.month = date.month;
  } else {
    form.year = year;
    form.month = month;
  }
};

const getCurrentDate = computed(() => {
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1);
  return { year, month };
});

onBeforeMount(async () => {
  loadDate();
  loadModel();
});

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(form.year) + " 年 " + _toDisplayString(form.month) + "月", 1),
          _createVNode(_component_Button, {
            class: "p-button-light mr-2 h-48px lg:col-2",
            label: "前月の設定へ",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (handleChangeMonth('prev')))
          }),
          _createVNode(_component_Button, {
            class: "p-button-light mr-2 h-48px lg:col-2",
            label: "翌月の設定へ",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (handleChangeMonth('next')))
          }),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Button, {
              label: "前月分をコピー",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (handleApplyPrevMonth())),
              class: "ml-5 w-100"
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("form", {
              onSubmit: _withModifiers(submit, ["prevent"]),
              ref_key: "formRef",
              ref: formRef
            }, [
              (form.value)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(WeekDays), (day, index) => {
                    return (_openBlock(), _createBlock(DateComponent, {
                      key: index,
                      name: day,
                      data: form.value,
                      onValidateFn: validate,
                      ref_for: true,
                      ref: 
                  el => {
                    dateElements.value[index] = el;
                  }
                
                    }, null, 8, ["name", "data"]))
                  }), 128))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value?.clinic_special_shift_settings_attributes, (specialDate, index) => {
                return (_openBlock(), _createBlock(SpecialDateComponent, {
                  key: specialDate,
                  data: specialDate,
                  index: index,
                  onOnDeleteDate: onDeleteDate,
                  onValidateFn: validate,
                  ref_for: true,
                  ref: 
                el => {
                  specialDateElements.value[index] = el;
                }
              
                }, null, 8, ["data", "index"]))
              }), 128)),
              _createVNode(_component_Button, {
                label: "追加する",
                onClick: addMoreSpecialDate,
                class: "mb-5"
              }),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_Button, {
                  label: "保存する",
                  type: "submit",
                  class: "w-7",
                  disabled: !_unref(get)(pass.value)
                }, null, 8, ["disabled"])
              ])
            ], 40, _hoisted_8)
          ])
        ])
      ])
    ]),
    _createVNode(_unref(Toast), { position: "top-center" })
  ], 64))
}
}

})